import { createTheme } from "@mui/material/styles";
import THEME from "../constants/theme";

const { colors } = THEME;

// Shared by the application and the exam's optional dark appearance.
export const createAppTheme = (mode = "light") => createTheme({
  palette: {
    mode,
    primary: { main: colors.primary, dark: colors.primaryHover, contrastText: "#fff" },
    secondary: { main: colors.secondary, dark: "#007D8A", contrastText: colors.dark },
    ...(mode === "light" ? {
      background: { default: colors.background, paper: colors.surface },
      text: { primary: colors.textPrimary, secondary: colors.textSecondary },
      divider: colors.border,
    } : {}),
  },
  typography: {
    fontFamily: '"Inter", "Segoe UI", Arial, sans-serif',
    fontSize: 14,
    body1: { fontSize: '0.875rem', lineHeight: 1.5 },
    body2: { fontSize: '0.875rem', lineHeight: 1.5 },
    subtitle1: { fontSize: '0.875rem', lineHeight: 1.5 },
    subtitle2: { fontSize: '0.875rem', lineHeight: 1.5 },
    caption: { fontSize: '0.75rem' },
    h1: { fontSize: '1.5rem', fontWeight: 700 },
    h2: { fontSize: '1.375rem', fontWeight: 700 },
    h3: { fontSize: '1.25rem', fontWeight: 700 },
    h4: { fontSize: '1.125rem', fontWeight: 700 },
    button: { fontSize: '0.875rem', textTransform: "none", fontWeight: 600 },
    h5: { fontSize: '1rem', fontWeight: 700, letterSpacing: "-0.025em" },
    h6: { fontSize: '0.9375rem', fontWeight: 700, letterSpacing: "-0.015em" },
  },
  shape: { borderRadius: 10 },
  components: {
    MuiButton: { defaultProps: { disableElevation: true }, styleOverrides: { root: { borderRadius: 10, minHeight: 38, paddingInline: 16 } } },
    MuiOutlinedInput: { styleOverrides: { root: { borderRadius: 10, minHeight: 38, fontSize: 14, ...(mode === "light" ? { backgroundColor: colors.surface, "& .MuiOutlinedInput-notchedOutline": { borderColor: colors.border }, "&:hover:not(.Mui-disabled):not(.Mui-error) .MuiOutlinedInput-notchedOutline": { borderColor: colors.primaryMedium }, "&.Mui-focused:not(.Mui-error)": { boxShadow: "0 0 0 3px rgba(0,87,255,.08)" }, "&.Mui-disabled": { backgroundColor: colors.surface2 }, "&.Mui-error .MuiOutlinedInput-notchedOutline": { borderColor: "#d32f2f" } } : {}) } } },
    MuiTextField: { defaultProps: { size: "small" } },
    MuiFormControl: { defaultProps: { size: "small" } },
    MuiInputLabel: { styleOverrides: { root: { fontSize: 14 } } },
    MuiFormHelperText: { styleOverrides: { root: { marginLeft: 0, marginTop: 6, lineHeight: 1.5 } } },
    MuiDialog: { styleOverrides: { paper: { borderRadius: 16, backgroundImage: "none", boxShadow: "0 24px 80px rgba(6,26,56,.18)" } } },
    MuiDialogTitle: { styleOverrides: { root: { padding: "24px 24px 16px", fontSize: 15, fontWeight: 700 } } },
    MuiDialogContent: { styleOverrides: { root: { padding: "16px 24px 24px" } } },
    MuiDialogActions: { styleOverrides: { root: { padding: "16px 24px", gap: 8, flexWrap: "wrap", borderTop: "1px solid", borderColor: mode === "light" ? colors.border : "rgba(255,255,255,.12)" } } },
    MuiMenu: { styleOverrides: { paper: { borderRadius: 12, boxShadow: "0 12px 40px rgba(6,26,56,.12)" } } },
    MuiCard: { styleOverrides: { root: { borderRadius: 16, boxShadow: "0 3px 16px rgba(6,26,56,.04)" } } },
    MuiTableCell: { styleOverrides: { root: { fontSize: 14 }, head: { fontWeight: 700, ...(mode === "light" ? { backgroundColor: colors.surface2, color: colors.dark } : {}) } } },
    MuiTooltip: { styleOverrides: { tooltip: { backgroundColor: colors.dark } } },
    MuiCssBaseline: { styleOverrides: { body: { backgroundColor: mode === "light" ? colors.background : "#121212" } } },
  },
});

export default createAppTheme();
